import React from 'react';
import { Switch, IconButton, Tooltip, Chip } from '@mui/material';
import { CheckCircleOutline, Close, Edit } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';

const userColumns = (handleToggleActive, handleEditUser, handleDeleteUser) => [
    { field: 'id', headerName: 'ID', width: 50 },
    { field: 'username', headerName: 'Username', width: 120 },
    { field: 'type_document', headerName: 'Tipo Documento', width: 100 },
    { field: 'first_name', headerName: 'Nombres', width: 130 },
    { field: 'last_name', headerName: 'Apellidos', width: 130 },
    { field: 'dni', headerName: 'Dni', width: 90 },
    {
        field: 'empresas',
        headerName: 'Empresas',
        width: 200,
        renderCell: (params) => (
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                {params.value.map((empresa, index) => (
                    <Chip key={index} label={empresa.empresa} color="primary" />
                ))}
            </div>
        ),
    },
    {
        field: 'lineas_negocio',
        headerName: 'Lineas Negocio',
        width: 200,
        renderCell: (params) => (
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {params.value.map((linea_negocio, index) => (
                    <Chip key={index} label={linea_negocio.linea_negocio} color="primary" />
                ))}
            </div>
        ),
    },
    {
        field: 'is_superuser',
        headerName: 'Is_superuser',
        width: 100,
        renderCell: (params) => (
            params.value ? <CheckCircleOutline color="success" /> : <Close color="error" />
        ),
    },
    {
        field: 'is_active',
        headerName: 'Activo',
        width: 130,
        renderCell: (params) => (
            <Switch
                checked={params.value}
                onChange={(e) => handleToggleActive(params.id, e.target.checked)}
            />
        ),
    },
    {
        field: 'actions',
        headerName: 'Acciones',
        width: 180,
        sortable: false,
        renderCell: (params) => (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                <Tooltip title="Editar Empresas">
                    <IconButton color="primary" onClick={() => handleEditUser(params.id)}>
                        <Edit />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Eliminar">
                    <IconButton color="secondary" onClick={() => handleDeleteUser(params.id)}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </div>
        ),
    },
];

export default userColumns;
